module.exports = __webpack_public_path__ + "img/pa.c66f2e36.svg";